<template>
  <div>
    <div v-if="!config[value]" class="rounded">
      <loading :loading="true" />
    </div>

    <div
      v-if="config[value]"
      class="show-status"
      :style="{ 'background-color': config[value].color }"
    >
      <span class="">{{ config[value].label }}</span>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'

export default {
  name: 'ShowStatus',
  components: { Loading },
  props: {
    value: null,
    config: {},
  },
}
</script>

<style scoped lang="scss">
.show-status {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  text-transform: uppercase;
  width: 100%;
  height: 100%;
}
</style>
